import { fromJS } from 'immutable';
import { get } from 'lodash';

export function request(state) {
    return state
        .setIn([ 'chatNightMode', 'state' ], 'IN_PROGRESS');
}

export function error(state, { errors }) {
    errors = fromJS(errors);

    return state
        .setIn([ 'chatNightMode', 'state' ], 'ERROR')
        .setIn([ 'chatNightMode', 'errors' ], errors);
}

export function finish(state, {data} ) {
    return state
        .setIn([ 'chatNightMode', 'state' ], 'FINISHED')
        .setIn([ 'chatNightMode', 'messageTemplates' ], get(data, 'templates.messageTemplates.0', ''))
        .setIn([ 'chatNightMode', 'scheduleStart' ], get(data, 'templates.scheduleStart', ''))
        .setIn([ 'chatNightMode', 'scheduleEnd' ], get(data, 'templates.scheduleEnd', ''));
}
